import React from 'react';
import HelloAppH5Page from '../hello-app-h5/common/HelloAppH5Page';
import { HelloBuyerAppH5Config } from './HelloBuyerAppH5Config';

const HelloBuyerAppH5Page: React.FC = () => (
  <HelloAppH5Page
    role="buyer"
    documentTitle={HelloBuyerAppH5Config.documentTitle}
    shareButtonLabel={HelloBuyerAppH5Config.shareButtonLabel}
    downloadButtonLabel={HelloBuyerAppH5Config.downloadButtonLabel}
    iosAppStoreUrl={HelloBuyerAppH5Config.iosAppStoreUrl}
    androidApkUrl={HelloBuyerAppH5Config.androidApkUrl}
    shareOpenBaseOnly
    backgroundImageUrl={`${process.env.PUBLIC_URL}/h5bg/buyer.png`}
    placeholderBackgroundColor="#12B362"
    buttonBackgroundColor="#ffffff"
    buttonTextColor="#1a1a1a"
  />
);

export default HelloBuyerAppH5Page;
